import ChartPanel from '/components/statistics/chart-panel'
import FilterBar from '/components/statistics/filter-bar'
import PageShell from '/components/statistics/page-shell'
import useClientStatistics from '/components/statistics/use-client-statistics'

const compactChartSetting = {
  yAxis: [{ label: 'count', width: 90 }]
}

const StatisticsTemplateChanges = () => {
  const { loading, periodDays, setPeriodDays, selectableTemplates, statistics, templateId, setTemplateId } = useClientStatistics()

  return (
    <PageShell title="Statistics Template Changes" heading="Statistics - Template Changes">
      <div className='flex flex-col gap-5 mt-5 pb-20'>
        <FilterBar
          periodDays={periodDays}
          setPeriodDays={setPeriodDays}
          templateId={templateId}
          setTemplateId={setTemplateId}
          selectableTemplates={selectableTemplates}
          summaryItems={[
            { title: 'Created', value: statistics.extraTotals.templatesCreated },
            { title: 'Updated', value: statistics.extraTotals.templateUpdates }
          ]}
        />

        <ChartPanel
          title='Template create and update trends'
          description='Shows when templates were created and how often they were updated in the selected period.'
          dataset={statistics.templateLifecycle}
          xAxis={{ scaleType: 'band', dataKey: 'bucket_label' }}
          series={[
            { dataKey: 'created', label: 'Templates created' },
            { dataKey: 'updated', label: 'Template updates' }
          ]}
          loading={loading}
          height={380}
          yAxis={compactChartSetting.yAxis}
        />
      </div>
    </PageShell>
  )
}

export default StatisticsTemplateChanges
